/** @jsxImportSource preact */
import {render} from "preact";
import UserCreate from "./user_create";

function wait(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}
document.addEventListener('DOMContentLoaded', async ()=>{
    await wait(1)
    const loginPlaceholder = document.querySelector('#ella_user_create')
    if(!loginPlaceholder) return
    render(<UserCreate />, loginPlaceholder);
    await wait(1)
    M.updateTextFields()
})

